(() => {
  const root = document.querySelector('[data-main-stories]');
  if (!root) return;
  const tabs = root.querySelector('.main-stories__tabs');

  let inFlight = null;

  const getContent = () => root.querySelector('[data-main-stories-content]');

  const isInternal = (a) => {
    if (!a || a.target === '_blank' || a.getAttribute('download')) return false;
    try {
      const u = new URL(a.href, location.origin);
      return u.origin === location.origin;
    } catch (_) {
      return false;
    }
  };

  const syncActiveTab = (url) => {
    const path = new URL(url, location.origin).pathname;
    root.querySelectorAll('.main-stories__tab').forEach((t) => {
      const tp = new URL(t.href, location.origin).pathname;
      const match = tp === path;
      t.classList.toggle('is-active', match);
      if (match) t.setAttribute('aria-current', 'page');
      else t.removeAttribute('aria-current');
    });
  };

  const scrollToTabs = () => {
    const target = tabs || getContent();
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.scrollY - 24;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  async function loadUrl(url, push = true) {
    const content = getContent();
    if (!content) return;
    if (inFlight) inFlight.abort();
    const ctrl = new AbortController();
    inFlight = ctrl;

    content.setAttribute('aria-busy', 'true');
    content.classList.add('is-loading');

    try {
      const res = await fetch(url, { signal: ctrl.signal, credentials: 'same-origin' });
      // 404 on /blog/tagged/X means no articles match — show empty state inline.
      if (res.status === 404) {
        content.innerHTML = '<p class="main-stories__empty paragraph-lg">No stories in this category yet.</p>';
        if (push) history.pushState({ msUrl: url }, '', url);
        syncActiveTab(url);
        scrollToTabs();
        return;
      }
      if (!res.ok) throw new Error(`fetch ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = doc.querySelector('[data-main-stories-content]');
      if (!next) {
        location.href = url;
        return;
      }
      content.innerHTML = next.innerHTML;
      if (push) history.pushState({ msUrl: url }, '', url);
      syncActiveTab(url);
      scrollToTabs();
    } catch (err) {
      if (err && err.name === 'AbortError') return;
      location.href = url;
    } finally {
      const c = getContent();
      if (c) {
        c.removeAttribute('aria-busy');
        c.classList.remove('is-loading');
      }
      inFlight = null;
    }
  }

  root.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a || !root.contains(a)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    if (!a.closest('.main-stories__tabs, .main-stories__pagination')) return;
    if (!isInternal(a)) return;
    e.preventDefault();
    loadUrl(a.href, true);
  });

  window.addEventListener('popstate', () => {
    loadUrl(location.href, false);
  });
})();
